import { mockHeadData } from 'utils/metaDataUtils/headData';
import type { HeaderNav } from 'interfaces/navigation/Header';
import type { PianoPageConfig } from 'services/Piano/entities/PianoPageConfig';
import { setPianoConfig } from 'services/Piano';
import type { NextPage } from 'next/types';
import mockPageData from 'src/main/lib/mockData/page-data';
import type { ArcSpanPageConfig } from 'services/ArcSpan/entities';
import { setarcSpanPageConfig } from 'services/ArcSpan';
import getFooter from 'api/Footer/getFooter';
import handleStaticPropsError from 'utils/handleStaticPropsError';
import getMenu from 'api/Header/getMenu';
import NewslettersPage from 'pages/Newsletters/NewslettersPage';
import type { Newsletter } from 'interfaces/Account';
import getNewsletters from 'lib/personalizationApi/getNewsletters';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { safeAsync } from 'utils/errorHandlingUtils';
import fallbackData from 'lib/fallbackData/commonData';
import { PianoExperiencePageType } from '@/app_lib/types/piano/Paywall';

interface NewslettersProps {
  newsletters: Newsletter[];
}

const NewslettersNextPage: NextPage<NewslettersProps> = ({ newsletters }: NewslettersProps) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_V3_KEY || ''}>
    <NewslettersPage
      newsletters={newsletters}
      isGuest
    />
  </GoogleReCaptchaProvider>
);

export default NewslettersNextPage;

export const getStaticProps = async () => {
  try {
    const newslettersHeadData = { ...mockHeadData };
    newslettersHeadData.title = 'Fortune Newsletters';
    newslettersHeadData.description =
      'Subscribe to Fortune newsletters to receive news, insights, and expert analysis from industry leaders on every facet of business.';
    newslettersHeadData.socialTitle = 'Subscribe to Fortune newsletters';
    newslettersHeadData.socialDescription =
      'Get the news, insights, and expert analysis from industry leaders on every facet of business delivered to your inbox.';
    const menu: HeaderNav = await safeAsync(
      () => getMenu('LEFT_MENU_COM', 'RIGHT_MENU_COM', 'TOPIC_NAVIGATION_COM', 'own', null),
      fallbackData.headerNav,
    );
    const footer = await safeAsync(() => getFooter(), fallbackData.footer);
    const newsletters = await getNewsletters();

    const arcSpanPageConfig: ArcSpanPageConfig = setarcSpanPageConfig(mockPageData);
    const pianoPageConfig: PianoPageConfig = setPianoConfig({
      pageType: PianoExperiencePageType.Default,
      pageData: {},
    });

    return {
      props: {
        arcSpanPageConfig,
        footer,
        headData: newslettersHeadData,
        headerNav: menu,
        newsletters,
        pianoPageConfig,
      },
      revalidate: 60,
    };
  } catch (e) {
    return handleStaticPropsError(e as Error);
  }
};
